import React from 'react'
import { Context } from './DetailContext'

export const useDetailContext = (): { clientId: any } => {
    const { clientId } = React.useContext(Context)
    return { clientId }
}
